<template id="backToTop">
  <div id="imagecont">
    <b-container v-show="picvisible">
      <b-container class="backrow bv-example-row bv-example-row-flex-cols">
        <b-row class="titlepos align-items-center">
          <b-col class="" align-self="center">
            Get Tires And Wheels Now And Pay Later!
          </b-col>
        </b-row>
      </b-container>

      <b-container class="bv-example-row">
        <b-row cols="12" class="buttonloc justify-content-md-center">
          <b-col col lg="4">
            <b-button
              block
              size="lg"
              class="buttontextsize"
              style="height: 70px; font-weight: bold;"
              :class="[isActive ? 'red' : 'blue']"
              @click="toggleClass()"
              >Enter Make / Model</b-button
            >
          </b-col>
          <b-col col lg="4">
            <b-button
              block
              size="lg"
              class="buttontextsize"
              style="height: 70px; font-weight: bold;"
              :class="[isActive ? 'blue' : 'red']"
              @click="toggleClassTwo()"
              >Enter VIN</b-button
            >
          </b-col>
        </b-row>
      </b-container>

      <b-container class="mt-4">
        <VandM :message="isActive"></VandM>
        <b-row class="justify-content-md-center align-items-center">
          <b-col cols="6">
            <hr />
          </b-col>
        </b-row>
        <b-row class="justify-content-md-center align-items-center">
          <b-col>
            <p style="color:darkgrey;">
              powered by ezfixd.com
            </p>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
    <transition name="fade">
      <div v-if="visible" class="vue-back-to-top">
        <VandM :message="msg" />
      </div>
    </transition>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'MainTires',
  props: {
    text: {
      type: String,
      default: 'text',
    },
    visibleoffset: {
      type: [String, Number],
      default: 600,
    },
    left: {
      type: String,
      default: '0px',
    },
    bottom: {
      type: String,
      default: '0px',
    },
  },
  data() {
    return {
      msg: 'i did it',
      showCreditCard: true,
      buttontoggler: 'primary',
      opbuttontoggler: 'outline-primary',
      myToggle: false,
      isActive: false,
      visible: false,
      picvisible: true,
      textone: 'omer',
      showstar: false,
      mycolor: '0E78E1',
      parameters: '',
    }
  },
  beforeMount() {
    this.parameters = this.$route.query.color
    console.log(this.parameters)
    console.log('this was before mount')
    console.log('Version 10.1 loaded')
  },

  methods: {
    toggleClass() {
      if ((this.isActive = true)) this.isActive = !this.isActive
    },
    toggleClassTwo() {
      if ((this.isActive = false)) console.log(this.isActive)
      this.isActive = !this.isActive
    },
    onpicOne() {
      if ('parentIFrame' in window) window.parentIFrame.size(560)
      return false
    },
    onpicTwo() {
      return [(this.visible = true), (this.picvisible = false)]
    },
  },
  template: '#backToTop',
}
</script>
<style scoped media="screen">
hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}
.align-items-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap');

@media screen and (min-width: 1501px) {
  .titlepos {
    font-size: 2vw;
  }
}
@media screen and (min-width: 1001px) and (max-width: 1500px) {
  .titlepos {
    font-size: 3.5vw;
  }
}
@media screen and (min-width: 401px) and (max-width: 1000px) {
  .titlepos {
    font-size: 5vw;
  }
}
@media screen and (max-width: 400px) {
  .titlepos {
    font-size: 7vw;
  }
}

@media screen and (min-width: 1001px) and (max-width: 1500px) {
  .buttontextsize {
    font-size: 2vw;
  }
}
@media screen and (min-width: 701px) and (max-width: 1000px) {
  .buttontextsize {
    font-size: 2.5vw;
  }
}
@media screen and (min-width: 401px) and (max-width: 700px) {
  .buttontextsize {
    font-size: 3vw;
  }
}
@media screen and (max-width: 400px) {
  .buttontextsize {
    font-size: 4vw;
  }
}
.titlepos {
  position: absolute;
  margin-left: 0px;
  margin-right: 0px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 250px;
  color: black;
  font-family: 'Open Sans', sans-serif;
  color: #3b3b3b;
}
.red {
  border-color: #109de7;
  background: white;
  color: black;
}

.blue {
  background-color: #109de7;
  border-color: #109de7;
}

.am-active {
  background-color: rgb(21, 79, 202);
  color: white;
}
.am-not-active {
  background-color: white;
}
.alignit {
  text-align: center;
  border: 3px solid green;
}
.buttonvin {
  background-color: white;
}
.buttonmake {
  background-color: #109de7;
}
.backrow {
  background: url('../assets/images/backwidg.png') center / cover no-repeat;
  width: 100%;
  height: 300px;
  object-fit: cover;
  position: relative;
}

.vue-back-to-top {
  z-index: 1000;
  cursor: pointer;
  position: fixed;
}
.buttonloc {
  margin-top: -20px;
}
</style>



// WEBPACK FOOTER //
// src/components/maintires.vue